import { Loading, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { StyledBody, StyledCell, StyledHead, StyledHeadCell, StyledRow, StyledTable } from 'baseui/table';
import { useStyles } from '../../hooks/useStyles';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = {
  data?: {
    items: [any, any];
    id: string;
    onClick: () => void;
  }[];
  loading?: boolean;
};

export function DistancesTable({ data, loading = false }: Props) {
  const { css } = useStyles();

  const optionsCellStyles = css({
    minWidth: '40px',
    maxWidth: '40px',
    boxSizing: 'content-box',
    justifyContent: 'center',
  });

  return (
    <StyledTable className={css({ minHeight: '100px', maxHeight: '200px' })}>
      <StyledHead role="row">
        <StyledHeadCell role="columnheader">Distancia</StyledHeadCell>
        <StyledHeadCell role="columnheader">Estado</StyledHeadCell>
        <StyledHeadCell className={optionsCellStyles} />
      </StyledHead>
      <StyledBody>
        {loading && <Loading />}
        {!loading &&
          data?.map((row, rowIndex) => (
            <StyledRow key={rowIndex}>
              {row.items.map((item, itemIndex) => (
                <StyledCell key={`${rowIndex}-${itemIndex}`}>{item}</StyledCell>
              ))}
              <StyledCell className={optionsCellStyles}>
                <StyledTooltip
                  content={'Ver en el mapa'}
                  placement="right"
                  showArrow={false}
                  ignoreBoundary
                >
                  <Button
                    size="mini"
                    shape="circle"
                    onClick={row.onClick}
                    kind="tertiary"
                  >
                    <MaterialIcon
                      name={'location_searching'}
                      size="mini"
                    />
                  </Button>
                </StyledTooltip>
              </StyledCell>
            </StyledRow>
          ))}
      </StyledBody>
    </StyledTable>
  );
}
